import {Injectable} from '@angular/core';

import {Observable} from 'rxjs';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../../enviroments/enviroment';
import {Sistema, SistemaImg} from '../model/sistema';



@Injectable({
  providedIn: 'root'
})
export class SistemaService {

  private urlEndPoint = environment.urlEndPoint + '/api/sistemas';
  private urlEndPointAdmin = environment.urlEndPoint + '/api/sistemas-admin';
  private httpHeaders = new HttpHeaders({'Content-type': 'application/json'});

  constructor(private http: HttpClient) {
  }

  findAll(): Observable<SistemaImg[]> {
    return this.http.get<SistemaImg[]>(`${this.urlEndPoint}/all`)
  }

  findAllByNombre(nombre: string): Observable<SistemaImg> {
    return this.http.get<SistemaImg>(`${this.urlEndPoint}/nombre?codigo=${nombre}`)
  }

  findAdminAll(): Observable<SistemaImg[]> {
    return this.http.get<SistemaImg[]>(`${this.urlEndPointAdmin}/all`)
  }

  //Modificar
  update(componente: Sistema): Observable<SistemaImg> {
    return this.http.put<SistemaImg>(`${this.urlEndPointAdmin}`, componente, {headers: this.httpHeaders});
  }

  addSistema(sistema: Omit<Sistema, 'id'>): Observable<Sistema> {
    return this.http.post<Sistema>(`${this.urlEndPointAdmin}`, sistema, {headers: this.httpHeaders});
  }
}
